import { useState, useEffect, useContext } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { motion } from 'framer-motion'

import TopoMenu from '../../../componentes/gerais/TopoMenu'
import AltMax from '../../../componentes/gerais/AltMax'
import MenuLateral from '../../../componentes/gerais/Menu'

import { styled, alpha } from '@mui/material/styles'

import { format, parse } from 'date-fns'

import { Alert, Backdrop, Button, Card, CircularProgress, Collapse, Divider, FormControl, FormLabel, IconButton, InputLabel, Menu, MenuItem, Popper, Select, Zoom, Snackbar } from '@mui/material'

import CardEndereco from '../../../componentes/form/CardEndereco'
import ServicoAPI from '../../../servicos/ServicoAPI'
import ProfissionalAPI from '../../../servicos/ProfissionalAPI'
import { ContextoGeral } from '../../../contextos/ContextoGeral'
import { Spinner } from '../../../componentes/Spinner'
import { configAnim } from '../../../servicos/config/configAnim'
import MensagemApp from "../../../servicos/config/MensagemApp.js"
import Refresher from '../../../componentes/uteis/Refresher'
import CheckPermission from '../../../servicos/config/CheckPermission.js'
import { MdCall, MdChangeCircle, MdContentCopy, MdExpandMore, MdExplore, MdLocationOn, MdMonetizationOn, MdOutlineExpandMore, MdPhone, MdSocialDistance, MdTimer } from 'react-icons/md'
import { FaWhatsapp } from 'react-icons/fa'

import icon from "./../../../assets/icones/relogio.svg"
import AlertDialog, { BootClickAlert, FakeGpsAlert } from '../../../componentes/gerais/Dialog'
import FakeGPSBlock from '../../../componentes/uteis/FakeGPSBlock'
import { copy, print, verificarBootClick, verificarFakeGPS } from '../../../servicos/Uteis'
import zIndex from '@mui/material/styles/zIndex.js'
import { DetalhesAcertado } from '../../../componentes/servicos/CardAcertado.jsx'
import { chamarTel, chamarWhats } from '../../../componentes/uteis/telefone.jsx'
import { BackHand, Call, Check, Close, CopyAll, Edit, Explore, QrCode, QrCodeScanner, WhatsApp } from '@mui/icons-material'
import ScannerColetaModal from '../../../componentes/servicos/ScannerColetaModal.jsx'
import FinalizarPorCodigoModal from '../../../componentes/servicos/FinalizarPorCodigoModal.jsx'
import { recursoQrCodeDisponivel, rotuloBotaoQrCode } from '../../../utils/finalizacaoQrCode.js'
import { isNativeApp } from '../../../servicos/config/nativeBridge.js'

import APISemNode from "./../../../servicos/APISemNode.js";
import { marcaIntegracao } from "../../../servicos/marcaIntegracao"
import { TimerColeta } from '../../../componentes/servicos/cardServico.jsx'
import {
	BotaoVerRota,
	MapaCotacaoSheet,
	deveExibirMapaServico,
	pontosMapaCotacao,
} from '../cotacoes/MapaCotacao'
import FabMinhaRota from '../../../componentes/FabMinhaRota'

export default function ServicoDetalhes() {
	const { id } = useParams()

	const navegar = useNavigate()

	const params = useParams()

	const [servico, setServico] = useState({})
	const [menu, setMenu] = useState(false)
	const [modalCodigoAberto, setModalCodigoAberto] = useState(false)
  
	const [carregando, setCarregando] = useState(true)
	const [spinMarcador, setSpinMarcador] = useState(false)
	const [showAction, setShowAction] = useState(true)

	const [exibirFakeGPS, setExibirFakeGPS] = useState(false)
	const [exibirBootClick, setExibirBootClick] = useState(false)

	const [endAtivo, setEndAtivo] = useState({})

	const [backdrop, setBackdrop] = useState(false)

	const [textoFinalizar, setTextoFinalizar] = useState('')

	const [BD, setBD] = useState(false)
	const [texto, setTexto] = useState('')
	const [BDCancel, setBDCancel] = useState(false)
	const [BDCancelAcerto, setBDCancelAcerto] = useState(false)
	const [cancelOpt, setCancelOpt] = useState('')
	const [cancelVal, setCancelVal] = useState('')
	const [cancelValido, setCancelValido] = useState(true)
	const [cancelarAcerto, setCancelarAcerto] = useState(false)
	const [sistemaFarmacia, setSistemaFarmacia] = useState(false)
	const [showDetails, setShowDetails] = useState(false)
	const [isClicking, setIsClicking] = useState(false)
	const [corDinamica, setCorDinamica] = useState(false)
	const [precoDinamico, setPrecoDinamico] = useState([])
	const [precoDinamicoProf, setPrecoDinamicoProf] = useState([])

	const [perguntaProximo, setPerguntaProximo] = useState("")

	const [snackPunicao, setSnackPunicao] = useState({
		open: false,
		msg: ''
	})
	const [modalMapa, setModalMapa] = useState(false)
	const [posProfMapa, setPosProfMapa] = useState(null)

	const { dados, setDados } = useContext(ContextoGeral)

	async function abrirMapaServico() {
		let local = { latitude: 0, longitude: 0 }
		try {
			if (window.AndroidInterface && typeof window.AndroidInterface.getLocation === "function") {
				const raw = await window.AndroidInterface.getLocation()
				if (raw && typeof raw === "string") local = JSON.parse(raw)
				else if (raw && typeof raw === "object") {
					local = { latitude: raw.latitude ?? 0, longitude: raw.longitude ?? 0 }
				}
			}
		} catch { /* ignore */ }
		if (window.location.origin.includes("localhost")) {
			local = { latitude: -19.934101, longitude: -44.157393 }
		}
		setPosProfMapa(local)
		setModalMapa(true)
	}

	const handleClose = (e) => {
		const BACKDROP = document.querySelector(`[data-id="backdrop"]`);
		const CURRENT_TARGET = e.target;

		if (BACKDROP?.children?.[0] == CURRENT_TARGET) {
			if (!spinMarcador) {
				setBackdrop(false)
			}
		}
	}

	const handleCloseBD = () => {
		setBD(false)
	}

	async function confirmarEndereco(data) {
		setEndAtivo(data)
	}

	function verGps() {
		if (window.AndroidInterface)
			if (endAtivo.laEnd && endAtivo.loEnd)
				window.AndroidInterface.abrirMaps(`${endAtivo.laEnd},${endAtivo.loEnd}`)
			else
				window.AndroidInterface.showAndroidVersion("")
		else
			console.error('Não está no Android')
	}


	async function conversarCliente() {

		const dominio = `https://${dados?.dominio}`;

		let rota = 'sem/v1/rotas.php/modulo-chat-profissional/validarStatusServico';
		let validarServico = false;
		if (dados?.dominio == 'mototaxionline.srv.br') {
			rota = 'sem/v1/rotas/modulo-chat-profissional/validarStatusServico';
		}

		await APISemNode.requisicaoGET(
			dominio,
			`status=${servico['s.status']}&idServico=${servico['s.id']}&idCliente=${servico['s.idSolicitante']}&idCentroCusto=${servico['s.idCentroCusto']}`,
			rota,
			dados?.token
		)
			.then(response => {

				if (response?.dados?.status) {


					validarServico = response?.dados?.dados > 0

				} else {
					console.error("houve um problema ao buscar mensagens:");
				}
			})
			.catch(error => {
				console.error("Erro ao buscar mensagens:");
			});

		if (validarServico) {

			await navegar(`/app/chat`, {
				state: {
					conversa: 'cliente',
					idServico: servico['s.id'],
					idSolicitante: servico['s.idSolicitante'],
					idCentroCusto: servico['s.idCentroCusto'],
					status: servico['s.status']
				}
			})
		} else {
			alert('Serviço encerrado')
		}

	}

	async function verificarAntifraude() {
		if (window.AndroidInterface?.isFakeGPS && window.AndroidInterface?.recoverVersion && window.AndroidInterface.recoverVersion() > 100.80) {
			if (dados?.configFakeGPS?.opcao != 'NF' && await window.AndroidInterface.isFakeGPS()) {
				setExibirFakeGPS(true)
			}

			if (dados?.configBootClick && (dados?.configBootClick?.opcao != 'NF' && await verificarBootClick())) {
				setExibirBootClick(true)
			}
		}
	}

	async function buscarDetalhesServico() {
		let retorno = await ServicoAPI.buscarServico(id, dados)

		if (retorno.resultado) {
			if (retorno.aux?.dadosProf) {
				if (retorno.aux.dadosProf?.status == "OL" && dados.statusOnline == false) {
					let json = dados
					json.statusOnline = true
					setDados(json)
				}
			}

			if(retorno?.dados[0]?.servico){
				setPrecoDinamico(retorno?.dados[0]?.servico)
			}

			if(retorno?.dados[0]?.profissional){
				setPrecoDinamicoProf(retorno?.dados[0]?.profissional)
			}

			if (retorno?.aux?.dadosProf?.corDinamica)
				setCorDinamica(retorno.aux.dadosProf.corDinamica == "S")

			if (retorno?.aux?.dadosProf?.exibeBotaoAcertar == "S")
				setCancelarAcerto(true)

			if (retorno?.aux?.dadosProf?.sistemaFarmacia == "S")
				setSistemaFarmacia(true)

			if (retorno?.dados) {
				if (retorno.dados[0].perguntaProximo)
					setPerguntaProximo(retorno.dados[0].perguntaProximo)

				setServico(retorno.dados[0])
			} else setServico({})
		}

		setCarregando(false)
	}

	async function marcarPonto() {
		handleCloseBD()
		setIsClicking(false)

		let bloqueio = false

		try {
			if (window.AndroidInterface?.isFakeGPS && window.AndroidInterface?.recoverVersion && window.AndroidInterface.recoverVersion() > 100.80) {
				if (dados?.configFakeGPS?.opcao != 'NF' && await window.AndroidInterface.isFakeGPS()) {
					setExibirFakeGPS(true)
					bloqueio = dados?.configFakeGPS?.opcao == "B"
				}

				if (dados?.configBootClick && (dados?.configBootClick?.opcao != 'NF' && await verificarBootClick())) {
					setExibirBootClick(true)

					if (!bloqueio)
						bloqueio = dados?.configBootClick?.opcao == "B"
				}

				if (bloqueio) return
			}

			setSpinMarcador(true)

			let statusPermissao = true

			if (statusPermissao && !CheckPermission.checkLocationAvailable()) {
				statusPermissao = false

				if (window.AndroidInterface)
					window.AndroidInterface.showPermissaoLocalizacao(MensagemApp.msgPermissaoGPS)
			}

			if (statusPermissao && !CheckPermission.checkLocationEnabled()) {
				statusPermissao = false
				if (window.AndroidInterface)
					window.AndroidInterface.showHabilitarLocalizacao(MensagemApp.msgHabilitarGPS)
			}

			if (statusPermissao) {
				let location = {
					latitude: 0,
					longitude: 0
				}

				if (window.AndroidInterface)
					location = JSON.parse(await window.AndroidInterface.getLocation())

				if (window.isLocalHost)
					location = { latitude: -21, longitude: -44 }

				if ((location == '') || (location.latitude == 0 || location.longitude == 0)) {
					if (typeof window.AndroidInterface !== 'undefined') {
						window.AndroidInterface.showAndroidVersion(MensagemApp.msgErroLaLo)
					} else {
						alert(MensagemApp.msgErroLaLo)
					}

				} else {
					let retorno = await ServicoAPI.marcarChegada(dados, endAtivo, location)

					if (retorno?.status == 200) {
						if (retorno.data?.mensagem) {
							if (!!window.AndroidInterface) {
								window.AndroidInterface.showAndroidVersion(retorno.data.mensagem)
							} else {
								alert(retorno.data.mensagem)
							}
						} else {
							if (!!window.AndroidInterface) {
								window.AndroidInterface.showAndroidVersion(MensagemApp.msgErroApi)
							} else {
								alert(MensagemApp.msgErroApi)
							}
						}

					} else if (retorno?.status == 404 || retorno?.status == 400) {
						if (!!window.AndroidInterface) {
							window.AndroidInterface.showAndroidVersion(retorno.data?.mensagem)
						} else {
							alert(retorno.data?.mensagem)
						}

					} else {
						if (!!window.AndroidInterface) {
							window.AndroidInterface.showAndroidVersion(MensagemApp.msgErroApi)
						} else {
							alert(MensagemApp.msgErroApi)
						}
					}
				}
			}
		} catch {
			console.error(MensagemApp.funcIndisponivel)
		}

		setSpinMarcador(false)
		setBackdrop(false)
		setCarregando(true)
	}

	async function acao() {
		setIsClicking(true)
		try {
			let bloqueio = false

			if (window.AndroidInterface?.isFakeGPS && window.AndroidInterface?.recoverVersion && window.AndroidInterface.recoverVersion() > 100.80) {
				if (dados?.configFakeGPS?.opcao != 'NF' && await window.AndroidInterface.isFakeGPS()) {
					setExibirFakeGPS(true)
					bloqueio = true
				}

				if (dados?.configBootClick && (dados?.configBootClick?.opcao != 'NF' && await verificarBootClick())) {
					setExibirBootClick(true)

					bloqueio = true
				}

				if (bloqueio) return
			}

			if (endAtivo.modo) {
				navegar(`/app/servicos/${id}/finalizar`, {
					state: endAtivo
				})
			} else {
				setTexto('Confirma sua chegada?')
				setBD(true)
			}
		} catch (err) {
			console.error(err)
		}
	}

	useEffect(() => {
		if (carregando === true) {
			verificarAntifraude()
			buscarDetalhesServico()
		}
	}, [carregando])

	useEffect(() => {
		if (Object.keys(servico).length != 0) {
			setCarregando(false)
		}
	}, [servico])

	useEffect(() => {
		if (endAtivo?.idServico !== undefined) {
			setTextoFinalizar(endAtivo.label)
			setBackdrop(true)
		}
	}, [endAtivo])

	return <motion.div
		className="h-screen"
		initial={configAnim.initial}
		animate={configAnim.animate}
		exit={configAnim.exit}
		transition={configAnim.transition}
	>
		<TopoMenu
			voltar="/app/servicos"
			titulo={"DETALHES DO SERVIÇO " + params.id}
			subtitulo={servico['s.numeroPedido'] ? "NUMERO PEDIDO: " + servico['s.numeroPedido'] : null}
			setShow={setMenu}
		/>

		{carregando
			? <div style={{
				height: 'calc(var(--app-vh) - 3rem)'
			}}>
				<Spinner />
			</div>
			: <>
				{Object.keys(servico).length > 0
					? (<>
						<div style={{ height: 'calc(var(--app-vh) - 3.3rem)', overflow: 'auto' }}>
							<div className="flex items-center text-white justify-between py-2 px-2 mt-2" style={{backgroundColor: 'black'}}>
								<h1 className='mb-0'>#{id}</h1>
								<div className="flex gap-2 items-center">
									{servico["s.dataHoraColetar"] != "0000-00-00 00:00:00"
										&& <div className="text-white-600">Agendado</div>}
									<div>
										<div className={"font-bold " + (servico["s.dataHoraColetar"] != "0000-00-00 00:00:00"
											? "text-white-600"
											: "")}>
											{format(parse(servico["s.dataHoraColetar"] != "0000-00-00 00:00:00"
												? servico["s.dataHoraColetar"]
												: servico['s.dataHora'], 'yyyy-MM-dd HH:mm:ss', new Date()), "dd/MM")}
										</div>
										<div className={"text-sm text-center " + (servico["s.dataHoraColetar"] != "0000-00-00 00:00:00"
											? "text-white-600"
											: "")} style={{ marginTop: '-0.5rem' }}>
											{format(parse(servico["s.dataHoraColetar"] != "0000-00-00 00:00:00"
												? servico["s.dataHoraColetar"]
												: servico['s.dataHora'], 'yyyy-MM-dd HH:mm:ss', new Date()), "HH:mm")}
										</div>
									</div>
								</div>
							</div>

							{servico['s.urgente'] == "S" && <div className='p-2 bg-red-600 flex items-center gap-2 text-white'>
								<img src={icon} alt="" style={{
									height: "1.25rem",
									filter: "brightness(10)"
								}} />
								Serviço Urgente
							</div>}

							{servico['s.freteExpresso'] != "" && <div className='p-2 bg-blue-500 flex items-center gap-2 text-white'>
								<MdMonetizationOn size={24} />
								Serviço Econômico
							</div>}

							{corDinamica && <div style={{ background: servico["so.corCliente"] }}>
								<h5 className="text-center text-white py-2" style={{
									textShadow: "0 2px 5px black, 0 1px 2px black, 0 -1px 6px black"
								}}>
									{servico["so.nome"]}
								</h5>
							</div>}

							<div className="flex justify-between px-2 mt-2 font-semibold">
								<div className="flex gap-2 items-center">
									{servico['s.descVeiculo'].toUpperCase()}
									<div className="opacity-50 flex items-center text-sm">
										<Explore sx={{ fontSize: "22px" }} />{servico["sa.direcao"] && servico["sa.direcao"]}
									</div>
								</div>

								{servico['s.distancia'] && (() => {
									// Se o backend retornou distância sem retorno, usar ela
									// Caso contrário, usar a distância normal
									const distanciaExibir = servico['s.distanciaSemRetorno'] || servico['s.distancia']
									const mostrarMensagemSemRetorno = !!servico['s.distanciaSemRetorno']
									
									// Formatar distância removendo zeros à direita (ex: 12,50 -> 12,5)
									const formatarDistancia = (valor) => {
										const num = typeof valor === 'string' ? parseFloat(valor) : parseFloat(valor)
										// Converte para string com vírgula e remove zeros à direita
										let str = num.toString().replace('.', ',')
										// Remove zeros à direita após a vírgula
										if (str.includes(',')) {
											str = str.replace(/0+$/, '')
											// Se sobrou só a vírgula, remove ela também
											str = str.replace(/,$/, '')
										}
										return str
									}
									
									return (
										<div className='flex items-center gap-1'>
											<MdSocialDistance />
											<div className='flex flex-col items-end'>
												<div>
													{formatarDistancia(distanciaExibir)}km
												</div>
												{mostrarMensagemSemRetorno && (
													<div className='text-xs opacity-60' style={{ fontSize: '0.65rem', marginTop: '-0.25rem' }}>
														sem retorno
													</div>
												)}
											</div>
										</div>
									)
								})()}

								{servico['s.duracaoRota'] > 0 && <div className='flex items-center gap-1'>
									<MdTimer />
									<div>
										{servico['s.duracaoRota'] && (servico['s.duracaoRota'] / 60).toFixed(0)} min
									</div>
								</div>}
							</div>
							<div className='flex items-center flex-col mt-4'>
								<h1 className="	text-green-600 mb-0 font-bold">
									{precoDinamico?.valorServico != null || precoDinamico?.valorAcrescimo != null
										? `${typeof precoDinamico?.valorServico === 'number' 
											? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(precoDinamico.valorServico)
											: (precoDinamico?.valorServico || '')} + ${typeof precoDinamico?.valorAcrescimo === 'number'
											? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(precoDinamico.valorAcrescimo)
											: (precoDinamico?.valorAcrescimo || '')}`
										: servico?.['s.valor'] && new Intl.NumberFormat('pt-BR', {
											style: 'currency',
											currency: 'BRL'
										}).format(servico['s.valor'])}
								</h1>
								<h3 className='	text-green-600 font-bold'>
									{precoDinamicoProf?.valorServico != null || precoDinamicoProf?.valorAcrescimo != null
										? `${typeof precoDinamicoProf?.valorServico === 'number'
											? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(precoDinamicoProf.valorServico)
											: (precoDinamicoProf?.valorServico || '')} + ${typeof precoDinamicoProf?.valorAcrescimo === 'number'
											? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(precoDinamicoProf.valorAcrescimo)
											: (precoDinamicoProf?.valorAcrescimo || '')}`
										: servico?.['s.valorProfissional'] && new Intl.NumberFormat('pt-BR', {
											style: 'currency',
											currency: 'BRL'
										}).format(servico['s.valorProfissional'])}
								</h3>
								<div className='text-sm  '>
									{servico['s.descPagamento'].toUpperCase()}
								</div>

								{servico.valorPorKm && <div className='	text-green-600'>
									Valor por KM: {servico.valorPorKm}
								</div>}
							</div>

							{servico?.taxaPagamento && <div className='p-3'>
								<Card className='mx-2 mb-4 p-3' style={{
									backgroundColor: "#eaa61d",
									width: "calc(100% - 1rem)",
									color: "white"
								}}>
									<h5 className='text-center'>{servico.taxaPagamento.titulo || 'Taxa de pagamento'}</h5>
									<div className="font-bold">
										{servico.taxaPagamento.labelTaxa || 'Taxa:'}
									</div>
									<div>
										{servico.taxaPagamento.taxa}
									</div>
									<div className="font-bold">
										{servico.taxaPagamento.labelValorTotalTaxa || 'Taxa Total:'}
									</div>
									<div>
										{servico.taxaPagamento.taxaTotal}
									</div>
									<div className="font-bold">
										{servico.taxaPagamento.labelFormagamento || 'Forma de pagamento:'}
									</div>
									<div>
										{servico.taxaPagamento.formaPagamento}
									</div>
								</Card>
							</div>}

							{servico.tempoColetarSegundosFalta && <div className='p-3'>
								<TimerColeta label={servico.tempoColetarMsg} tempoInicial={servico.tempoColetarSegundosFalta} tempoMax={servico.tempoMax} />
							</div>}

							<div className='flex justify-center opacity-75 text-sm mt-4'>
								<div className='flex flex-col w-full items-center' onClick={() => {
									setShowDetails(prev => !prev)
								}}>
									{servico.ifood && <Card className='mx-2 mb-4 p-3' style={{
										backgroundColor: marcaIntegracao(servico).fundo,
										width: "calc(100% - 1rem)",
										color: marcaIntegracao(servico).texto
									}}>
										<h4 className='text-center mb-4  '>Integração {marcaIntegracao(servico).nome}</h4>
										<div className='leading-none my-2  '>
											Nº do pedido: <b>{servico.ifood.pedido}</b>
										</div>
										{servico.ifood.total && <div className='leading-none my-2  '>
											Total: <b>{new Intl.NumberFormat('pt-BR', {
												style: 'currency',
												currency: 'BRL'
											}).format(servico.ifood.total)}</b>
										</div>}
										{servico.ifood.troco && <div className='leading-none my-2  '>
											Troco: <b>{new Intl.NumberFormat('pt-BR', {
												style: 'currency',
												currency: 'BRL'
											}).format(servico.ifood.troco)}</b>
										</div>}
										<div className='leading-none my-2  '>
											forma de pagamento {marcaIntegracao(servico).nome}: <b>{servico.ifood.forma_pagamento}</b>
										</div>
									</Card>}
									
									{servico['s.tipo'] == "AAI" && <Card className='mx-2 mb-4 p-3' style={{
										backgroundColor: "rgb(56 182 255)",
										width: "calc(100% - 1rem)",
										color: "white"
									}}>
										<h5 className='text-center mb-4  '>Integração AnotaAi</h5>
										<div className='leading-none my-2 text-lg'>
											Nº do pedido: <b className='ml-[5%] text-[44px]'>{servico['s.numeroPedido']}</b>
										</div>
									<div className='text-lg flex items-center'>Nome: {servico['so.nome']}</div>
									</Card>}
									<MdExpandMore />
								</div>
							</div>

							<Collapse
								className='px-2 bgPri text-white'
								style={{ marginBottom: '-0.5rem' }}
								in={showDetails}
							>
								<div className="flex justify-between text-sm my-4">
									<div>
										<div className='truncate opacity-75 text-sm'>Solicitante</div>
										<div className='truncate'>
											<strong>{servico['s.nomeSolicitante']}</strong>
										</div>
									</div>
									<div style={{ textAlign: 'end' }}>
										<div className='truncate opacity-75 text-sm'>Nº do pedido</div>
										<div className='truncate'>
											<strong>{servico['s.numeroPedido']}</strong>
										</div>
									</div>
								</div>
								<div className="flex justify-between text-sm my-4">
									<div>
										<div className='truncate opacity-75 text-sm'>E-mail</div>
										<div className='truncate'>
											<strong>{servico['so.email']}</strong>
										</div>
									</div>
								</div>

								<div className="flex justify-between text-sm my-4">
									<div>
										<div className='truncate opacity-75 text-sm'>Nome</div>
										<div className='truncate'>
											<strong>{servico['so.nome']}</strong>
										</div>
									</div>
								</div>
								<div className="flex justify-between text-sm my-4">
									<div>
										<div className='truncate opacity-75 text-sm'>Empresa</div>
										<div className='truncate'>
											<strong>{servico['so.empresa']}</strong>
										</div>
									</div>
								</div>
								<div className="flex justify-between text-sm my-4">
									<div>
										<div className='truncate opacity-75 text-sm'>Nome Fantasia</div>
										<div className='truncate'>
											<strong>{servico['so.nomeFantasia']}</strong>
										</div>
									</div>
								</div>

								<div className="flex justify-between text-sm my-4">
									<div>
										<div className='truncate opacity-75 text-sm'>Telefone fixo</div>
										<div className='truncate'>
											<strong>{servico['so.telFixo']}</strong>
											<div className="flex justify-start gap-x-7">
												<IconButton onClick={() => chamarTel(servico['so.telFixo'])} style={{ color: "white" }}>
													<MdCall size={28} />
												</IconButton>
												<IconButton onClick={() => chamarWhats(servico['so.telFixo'])} style={{ color: "white" }}>
													<FaWhatsapp size={28} />
												</IconButton>
											</div>
										</div>
									</div>
									<div style={{ textAlign: 'end' }}>
										<div className='truncate opacity-75 text-sm'>Telefone celular</div>
										<div className='truncate'>
											<strong>{servico['so.celular']}</strong>
											<div className="flex justify-end  gap-x-7">
												<IconButton onClick={() => chamarTel(servico['so.celular'])} style={{ color: "white" }}>
													<MdCall size={28} />
												</IconButton>
												<IconButton onClick={() => chamarWhats(servico['so.celular'])} style={{ color: "white" }}>
													<FaWhatsapp size={28} />
												</IconButton>
											</div>
										</div>
									</div>
								</div>
								<div className="flex justify-between text-sm my-4">
									<div>
										<div className='truncate opacity-75 text-sm'>Centro de custo</div>
										<div style={{ width: "100%" }}>
											{servico['s.nomeCentroCusto'] ?? "-"}
										</div>
									</div>
								</div>

								{servico.cancelamento.status && <div className='mx-auto text-center w-3/4 my-4'>
									<button
										onClick={() => setBDCancel(true)}
										className="w-full   !bg-red-600 text-white px-4 py-2 rounded !hover:bg-red-700 !border-4 !border-white transition"
									>
										Cancelar serviço
									</button>

								</div>}
							</Collapse>

							<Collapse in={sistemaFarmacia}>
								<div className="m-3 flex flex-col">
									<button
										onClick={() => setBDCancelAcerto(true)}
										className="w-full bg-red-600 text-white font-semibold px-4 py-2 rounded hover:bg-red-700 transition"
									>
										Cancelar Farmácia
									</button>

								</div>
							</Collapse>
							<Collapse in={sistemaFarmacia}>
								<div className="m-3 flex flex-col mt-4">
									<DetalhesAcertado servico={servico} />
								</div>
							</Collapse>

							{/* <div
									style={{
										position: 'fixed',
										bottom: '20px', // distância do rodapé
										right: '20px', // distância da direita
										zIndex: 1000, // para garantir que o botão fique sobre outros elementos
									}}
								>
									<Button
										variant='contained'
										style={{
											backgroundColor: '#100940',
											borderRadius: '50%',
											width: '60px',
											height: '60px',
										}}
										onClick={() => {
											conversarCliente();
										}}
									>
										<ChatIcon style={{ color: 'white' }} />
									</Button>
								</div> */}

							<Divider className="my-2" />

							{deveExibirMapaServico(servico) && pontosMapaCotacao(servico.enderecos).length > 0 && (
								<div className="px-2 mb-2">
									<BotaoVerRota onClick={abrirMapaServico} />
								</div>
							)}

							{recursoQrCodeDisponivel(dados) && (
								<div className="px-2 mb-2">
									<Button
										fullWidth
										variant="outlined"
										startIcon={<QrCodeScanner />}
										onClick={() => setModalCodigoAberto(true)}
										sx={{
											borderColor: 'var(--primaria-pura)',
											color: 'var(--primaria-pura)',
											py: 1.2
										}}
									>
										{rotuloBotaoQrCode(dados)}
									</Button>
								</div>
							)}

							<FinalizarPorCodigoModal
								open={modalCodigoAberto}
								onClose={() => setModalCodigoAberto(false)}
								idServico={id}
							/>

							<div>
								{servico && servico.enderecos && Array.isArray(servico.enderecos) && servico.enderecos.map((end, i) => {
									let desativado = false
									let dadosEnderecoAtivo = {
										idServico: id,
										modo: false,
									}

									let trocarPonto = false
									if (end?.['es.botaoCheguei']) {
										if (end['es.botaoCheguei'] != '') {
											dadosEnderecoAtivo = {
												...dadosEnderecoAtivo,
												label: end['es.botaoCheguei']
											}
										} else if (end['es.botaoFinalizar'] != '') {
											dadosEnderecoAtivo = {
												...dadosEnderecoAtivo,
												modo: true,
												label: end['es.botaoFinalizar']
											}
										} else {
											desativado = true
										}
									} else
										if (end['es.botaoFinalizar'] == '') {
											desativado = true
										} else {
											dadosEnderecoAtivo.modo = true
											dadosEnderecoAtivo.label = end['es.botaoFinalizar']
										}

									if (servico["proximoEndInformado"]) {
										if (end["e.id"] != servico["proximoEndInformado"])
											desativado = true
										else trocarPonto = true
									}

									return <Zoom
										key={'endereco' + i}
										in={Object.keys(servico).length > 0}
										style={{
											transitionDelay: (servico.enderecos?.length > 0) ? i * (1000 / Object.values(servico).length) : 0
										}}
									>
										<div className={`relative ${desativado ? 'opacity-90' : ''} mx-2`}>
											<CardEndereco
												id={i + 1}
												onClick={() => {
													dadosEnderecoAtivo.idAtivo = i + 1
													dadosEnderecoAtivo.endereco = end['e.rua']
													dadosEnderecoAtivo.observacao = end['e.responsavel']
													dadosEnderecoAtivo.idEndereco = end['e.id']
													dadosEnderecoAtivo.laEnd = end['e.la']
													dadosEnderecoAtivo.loEnd = end['e.lo']
													dadosEnderecoAtivo.tipoVeiculo = servico['s.mototaxi']
													dadosEnderecoAtivo.telefone = end['e.telefone']
													dadosEnderecoAtivo.contato = end['e.contato']
													dadosEnderecoAtivo.confirmaEntrega = end['e.clienteConfirma']
													if (typeof end['codigoLocalizadorIfood'] != "undefined")
														dadosEnderecoAtivo.codigoIfood = end['codigoLocalizadorIfood']
													console.log(end)
													setShowAction(desativado)

													confirmarEndereco(dadosEnderecoAtivo)
												}}
												retorno={servico['s.retorno'] == 'S' && (servico.enderecos.length - 1) == i}
												endereco={end['e.rua']}
												complemento={end['e.complemento']}
												tel={end['e.telefone']}
												contato={end['e.contato']}
												recebimento={end['e.endPontoReceber']}
												valor={servico['s.valor']}
												icone={desativado}
												trocarPonto={trocarPonto}
												cor={end["corPonto"]}
												confirmaEntrega={end["e.clienteConfirma"]}
											/>
											{trocarPonto && <IconButton className="!absolute"
												style={{
													bottom: "-0.5rem",
													left: "1rem",
													background: "white",
													boxShadow: "0 0 15px -3px black"
												}}
												onClick={() => {
													setPerguntaProximo("Troque seu próximo ponto")
												}}
												fullWidth>
												<MdChangeCircle size={30} />
											</IconButton>}
										</div>
									</Zoom>
								})}
							</div>
							{servico['s.pontoReceber'] != "" && <div className='mx-2'>
								<div className='p-2 text-sm mt-4 text-white' style={{ backgroundColor: "var(--primaria-darker)" }}>
									<h4 className='text-center font-bold'>Observação</h4>
									{servico['s.pontoReceber']}
								</div>
							</div>}
						</div>
					</>)
					: <>
						<Refresher
							setCarregando={setCarregando}
						/>
						<Alert severity="error" className="mx-3 mt-4 text-center">
							{MensagemApp.msgErroApi}
						</Alert>

					</>
				}
			</>}

		<FakeGpsAlert
			open={exibirFakeGPS}
			setOpen={setExibirFakeGPS}
			opcao={dados?.configFakeGPS?.opcao}
			onClose={() => {
				if (!exibirBootClick && isClicking) {
					if (endAtivo.modo) {
						navegar(`/app/servicos/${id}/finalizar`, {
							state: endAtivo
						})
					} else {
						setTexto('Confirma sua chegada?')
						setBD(true)
					}
				}
			}} />

		<BootClickAlert
			open={exibirBootClick}
			setOpen={setExibirBootClick}
			opcao={dados?.configBootClick?.opcao}
			onClose={() => {
				if (!exibirFakeGPS && isClicking) {
					if (endAtivo.modo) {
						navegar(`/app/servicos/${id}/finalizar`, {
							state: endAtivo
						})
					} else {
						setTexto('Confirma sua chegada?')
						setBD(true)
					}
				}
			}} />

		<MenuLateral show={menu} setShow={setMenu} />
		<FakeGPSBlock />

		<Backdrop
			sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
			open={backdrop}
			onClick={handleClose}
			data-id="backdrop"
		>

			<AltMax>
				<div className="rodapeFloat">
					{endAtivo.confirmaEntrega && <>
						{endAtivo.confirmaEntrega == "S"
							? <Alert icon={false}>
								<div className='text-center'><Check /></div>
								<div className='text-center'>Cliente confirmou que poderá receber</div>
							</Alert>
							: <Alert severity="error" icon={false}>
								<div className='text-center'><Close className="mx-auto" /></div>
								<div className='text-center'>Cliente informou que <b>NÃO</b> poderá receber</div>
							</Alert>}
					</>}
					<CardEndereco
						id={endAtivo.idAtivo}
						endereco={endAtivo.endereco}
						observacao={endAtivo.observacao}
						icone
					/>

					{endAtivo.codigoIfood && <div
						className='shadow-md rounded p-4 mt-4'
						style={{
							backgroundColor: marcaIntegracao(servico).fundo,
							color: marcaIntegracao(servico).texto,
						}}
					>
						<div className='flex justify-between gap-3 text-sm'>
							<div>
								<div>Código Localizador {marcaIntegracao(servico).nome}</div>
								<div className='text-center'>
									{endAtivo.codigoIfood}
								</div>
							</div>
							<IconButton color="primary" onClick={() => copy(endAtivo.codigoIfood)}>
								<MdContentCopy />
							</IconButton>
						</div>
					</div>}

					{endAtivo.contato && endAtivo.contato != '' && <div className="w-full gap-x-0 text-center mb-2" style={{ gap: '0.5rem' }}>
						<div className="mt-2 mb-0" style={{ fontSize: '0.66rem' }}>
							<b>CONTATO</b>
						</div>
						<div className="text-sm" style={{ lineHeight: 1, opacity: 0.6 }}>
							{endAtivo.contato}
						</div>
					</div>}

					{!showAction && <div className="w-full">
						<div className="flex justify-center items-center mt-4">
							{endAtivo.telefone
								? endAtivo.laEnd && endAtivo.loEnd && <IconButton color="primary" onClick={verGps}>
									<MdLocationOn />
								</IconButton>
								: endAtivo.laEnd && endAtivo.loEnd && <Button
									className="mx-auto mt-4"
									variant="outlined"
									startIcon={<MdLocationOn />}
									onClick={verGps}
								>
									GPS
								</Button>}

							{endAtivo.telefone && <div className="gap-2">
								<small id="telLigacao">
									{endAtivo.telefone}
								</small>
								<IconButton color="primary" onClick={() => copy(document.querySelector("#telLigacao").textContent)}>
									<MdContentCopy />
								</IconButton>
							</div>}

							<div>
								{endAtivo.telefone && <IconButton color="primary" onClick={() => chamarWhats(endAtivo.telefone)}>
									<FaWhatsapp />
								</IconButton>}
								{endAtivo.telefone && <IconButton color="primary" onClick={() => chamarTel(endAtivo.telefone)}>
									<MdPhone />
								</IconButton>}
							</div>

						</div>

						<div className="col-12 mt-4">
							<div style={{ flex: 1 }}>
								{spinMarcador ? (
									<Button
										color='primary'
										className="w-full"
										variant='outlined'
										disabled
									>
										<div className='py-3'>
											<Spinner />
										</div>
									</Button>
								) : (
									<div onClick={() => {
										if (!dados.statusOnline) {
											if (typeof window.AndroidInterface !== 'undefined') {
												window.AndroidInterface.showAndroidVersion('Fique online')
											} else {
												alert('Fique online')
											}
										}
									}}>
										<Button
											onClick={() => {
												acao()
											}}
											style={{ fontSize: '1.2rem' }}
											className="w-full"
											color='primary'
											variant="contained"
											disabled={!dados.statusOnline}
										>
											<b className='text-white'>
												{textoFinalizar}
											</b>
										</Button>
									</div>
								)}
							</div>
						</div>
					</div>}

				</div>
			</AltMax>
		</Backdrop>

		<Backdrop
			sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}
			open={BD}
		>
			<Card className="p-3">
				<h4 className='mb-4'>Confirme sua solicitação</h4>
				<p className='text-center text-sm'>
					{texto}
				</p>
				<div className="flex justify-center gap-3">
					<div>
						<button
							onClick={marcarPonto}
							className="w-full px-4 py-2 rounded !bg-green-600 text-white hover:bg-green-700 transition font-semibold"
						>
							CONFIRMAR
						</button>
					</div>
					<div>
						<button
							onClick={handleCloseBD}
							className="w-full px-4 py-2 rounded !bg-transparent !text-red-600 border border-red-600 hover:bg-red-50 transition font-semibold"
						>
							CANCELAR
						</button>

					</div>
				</div>
			</Card>
		</Backdrop>


		{
			!!servico.cancelamento && <Backdrop
				sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}
				open={BDCancel}
			>
				<Card className='p-3 mx-3'>
					<h5 className='text-center font-semibold'>Confirma cancelar?</h5>
					<div className='font-normal mt-3'>
						O serviço <b>{id}</b> será cancelado
					</div>
					{!!servico.cancelamento.opcoes && servico.cancelamento.opcoes.length > 0
						? <Select
							fullWidth
							displayEmpty
							className={'w-full rounded mt-4 ' + (cancelValido ? '' : 'text-red-600')}
							value={
								cancelOpt === "" && cancelVal === ""
									? ""
									: `${cancelOpt};${cancelVal}`
							}
							onChange={(e) => {
								const [opt, val] = e.target.value.split(";");
								setCancelOpt(opt || "");
								setCancelVal(val || "");
							}}
							IconComponent={MdOutlineExpandMore}
							renderValue={(selected) => {
								if (!selected) {
									return <span style={{ color: 'black' }}>Selecione um motivo</span>;
								}
								return selected.split(";")[0]; // mostra só o label no campo
							}}
							sx={{
								'& .MuiSelect-select': {
									paddingTop: '0.45rem',
									paddingBottom: '0.45rem'
								}
							}}
						>
							{/* Este item nunca será re-selecionável, só serve como valor default */}
							<MenuItem value="" disabled hidden>
								Selecione um motivo
							</MenuItem>

							{servico.cancelamento.opcoes.map((item) => (
								<MenuItem key={item.label} value={`${item.label};${item.value}`}>
									{item.label}
								</MenuItem>
							))}
						</Select>

						: ''}
					<div className='mt-4 flex gap-4'>
						<div className='w-1/2'>
							<Button
								color="success"
								variant="contained"
								className="w-full"
								onClick={async () => {
									if (cancelOpt == '') {
										setCancelValido(false)
									} else {
										setCancelValido(true)

										let retorno = await ServicoAPI.cancelarServico(dados, id, cancelVal, cancelOpt)
										if (!!window.AndroidInterface) {
											window.AndroidInterface.showAndroidVersion(retorno.mensagem)
										} else {
											alert(retorno.mensagem)
										}

										if (retorno.resultado) {
											try {
												// Verifica se o profissional foi punido após o cancelamento
												const retornoAtivo = await ProfissionalAPI.buscarAtivo(dados)

												if (retornoAtivo?.resultado) {
													const rawStatus = retornoAtivo.dados?.status
													const statusAtivo = typeof rawStatus === 'string'
														? rawStatus
														: rawStatus?.ativo

													// Considera como bloqueado quando ativo = 'P' (punido) ou 'U' (outro tipo de bloqueio)
													if (statusAtivo === 'P' || statusAtivo === 'U') {
														const msgConfigurada = retornoAtivo.dados?.mensagemBloqueio
														const msgDefault = 'Você foi temporariamente bloqueado por cancelar serviços após o aceite.'

														setSnackPunicao({
															open: true,
															msg: msgConfigurada || msgDefault
														})

														setBDCancel(false)

														// Aguarda um pouco para o aviso ser exibido antes de sair da tela
														setTimeout(() => {
															navegar("/app/servicos")
														}, 2500)

														return
													}
												}
											} catch (e) {
												console.error('Falha ao verificar punição após cancelamento:', e)
											}

											// Se não estiver punido ou em caso de erro na verificação, segue fluxo normal
											navegar("/app/servicos")
										} else {
											setBDCancel(false)
											setCarregando(true)
										}
									}
								}}
							>
								Confirmar
							</Button>
						</div>
						<div className='w-1/2'>
							<button
								onClick={() => { setBDCancel(false) }}
								className="w-full px-4 !py-2 rounded !text-red-600 !bg-white transition font-semibold"
								style={{ marginTop: '0rem' }}
							>
								Cancelar
							</button>
						</div>
					</div>
				</Card>
			</Backdrop>
		}
		<CancelAcerto open={BDCancelAcerto} onClose={() => {
			setBDCancelAcerto(false)
			setTimeout(() => navegar("/app/servicos"), 1000)
		}} />
		{
			servico.enderecos && <GerenciarColetas
				show={servico.exibirColetas == true && !carregando}
				enderecos={servico.enderecos}
				categoria={servico["s.mototaxi"]}
				retorno={servico["s.retorno"] == "S"}
				exigirSalvarBarcode={servico.exigirSalvarBarcode !== false}
				reload={() => setCarregando(true)}
			/>
		}
		{
			servico.enderecos && <ListaEnderecos
				show={perguntaProximo}
				pergunta={perguntaProximo}
				enderecos={servico.enderecos}
				reload={() => {
					setPerguntaProximo("")
					setCarregando(true)
				}}
			/>
		}
		<Snackbar
			open={snackPunicao.open}
			autoHideDuration={4000}
			onClose={(_, reason) => {
				if (reason === 'clickaway') return
				setSnackPunicao(prev => ({ ...prev, open: false }))
			}}
			anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
			sx={{
				'&.MuiSnackbar-root': {
					top: '50% !important',
					left: '50% !important',
					transform: 'translate(-50%, -50%)',
				},
			}}
		>
			<Alert
				onClose={() => setSnackPunicao(prev => ({ ...prev, open: false }))}
				severity="warning"
				variant="filled"
				sx={{ borderRadius: '999px' }}
			>
				{snackPunicao.msg}
			</Alert>
		</Snackbar>
		<MapaCotacaoSheet
			open={modalMapa}
			onClose={() => setModalMapa(false)}
			cotacao={servico}
			posProf={posProfMapa}
		/>
		<FabMinhaRota
			badge={Array.isArray(servico?.enderecos) ? servico.enderecos.length : 0}
			visible={!carregando && Object.keys(servico).length > 0}
		/>
	</motion.div>
}

function GerenciarColetas({ show, enderecos, retorno, categoria, exigirSalvarBarcode = true, reload }) {
	const { id } = useParams()
	const { dados } = useContext(ContextoGeral)
	const [scannerWebAberto, setScannerWebAberto] = useState(false)

	function readQR() {
		if (exigirSalvarBarcode === false) {
			setScannerWebAberto(true)
			return
		}

		if (isNativeApp()) {
			window.AndroidInterface.ativaCamera('DC', Number(dados.idProf), Number(id), "", "S", "", "receberNumeroNota", dados.token)
			return
		}

		alert("não está no celular")
	}

	useEffect(() => {
		if (exigirSalvarBarcode === false) return

		window.finalizouEnvio = (res) => {
			try {
				res = JSON.parse(res)

				if (res?.resultado) {
					print(res.mensagem)
					reload()
				}
			} catch {
				alert(res.mensagem ?? "falha ao receber informações!")
			}
		}
	}, [exigirSalvarBarcode, reload])

	return <>
		<ScannerColetaModal
			open={scannerWebAberto}
			onClose={() => setScannerWebAberto(false)}
			idServico={id}
			dados={dados}
			onSuccess={reload}
		/>
		<Backdrop in={show} unmountOnExit>
		<Card className="p-2 mx-3">
			<h5 className="text-center  ">Confirme suas coletas</h5>

			<Button
				color="success"
				onClick={readQR}
				className='mb-4'
				fullWidth
			>
				<QrCode /> Ler Código QR
			</Button>
			<div style={{
				maxHeight: "55vh",
				overflow: "auto",
			}}>
				{enderecos.map((endereco, i) => {
					if ((i != 0 && i != enderecos.length - (retorno ? 1 : 0)))
						return <BlocoColeta
							key={i}
							endereco={endereco}
							categoria={categoria}
							reload={reload}
						/>
				})}
			</div>
		</Card>
	</Backdrop>
	</>
}

function BlocoColeta({ key, endereco, reload, categoria }) {
	const navegar = useNavigate()
	const { id } = useParams()
	const { dados } = useContext(ContextoGeral)

	const [loading, setLoading] = useState(false)

	async function confirm(end) {
		setLoading(true)
		try {
			const res = await ServicoAPI.confirmarColeta(dados, {
				idProf: dados.idProf,
				idServico: id,
				idEndereco: end["e.id"]
			})

			console.log("GIF", loading);
			console.log("Resposta da API:", res);

			if (res.resultado) {
				print(`ponto ${end["es.ponto"]} confirmado com sucesso`)
				setTimeout(() => reload(), 500)
			} else {
				alert("Erro ao confirmar coleta do ponto.")
			}
		} catch (e) {
			console.error("Erro ao confirmar coleta:", e)
			alert("Erro ao confirmar coleta.")
		}
		// finally {
		// 	setLoading(false)
		// }
	}


	async function report(end) {
		setLoading(true)

		try {
			let dadosEnderecoAtivo = {
				idServico: id,
				modo: false,
			}

			if (end?.['es.botaoCheguei']) {
				if (end['es.botaoCheguei'] != '')
					dadosEnderecoAtivo = {
						...dadosEnderecoAtivo,
						label: end['es.botaoCheguei']
					}
				else if (end['es.botaoFinalizar'] != '')
					dadosEnderecoAtivo = {
						...dadosEnderecoAtivo,
						modo: true,
						label: end['es.botaoFinalizar']
					}
			} else if (end['es.botaoFinalizar'] != '') {
				dadosEnderecoAtivo.modo = true
				dadosEnderecoAtivo.label = end['es.botaoFinalizar']
			}

			dadosEnderecoAtivo.idAtivo = end['es.ponto']
			dadosEnderecoAtivo.endereco = end['e.rua']
			dadosEnderecoAtivo.observacao = end['e.responsavel']
			dadosEnderecoAtivo.idEndereco = end['e.id']
			dadosEnderecoAtivo.laEnd = end['e.la']
			dadosEnderecoAtivo.loEnd = end['e.lo']
			dadosEnderecoAtivo.tipoVeiculo = categoria
			dadosEnderecoAtivo.telefone = end['e.telefone']
			dadosEnderecoAtivo.contato = end['e.contato']
			dadosEnderecoAtivo.confirmaEntrega = end['e.clienteConfirma']

			navegar(`/app/servicos/${id}/finalizar`, {
				state: dadosEnderecoAtivo
			})

		} catch (error) {
			console.error("Erro ao reportar endereço:", error)
			alert("Falha ao redirecionar para finalização. Tente novamente.")
		} finally {
			setLoading(false)
		}
	}

	async function clearAddress(idEndereco) {
		setLoading(true)

		try {
			const res = await ServicoAPI.limparEndereco(dados, {
				idProf: dados.idProf,
				idEndereco: idEndereco
			})

			console.log("GIF", loading);
			console.log("Resposta da API:", res);

			if (res.resultado) {
				print(`Ponto limpado com sucesso`)
				setTimeout(() => reload(), 500)
			} else {
				alert("Falha ao limpar ponto.")
			}
		} catch (error) {
			console.error("Erro ao limpar endereço:", error)
			alert("Erro de rede ou falha inesperada ao limpar ponto.")
		} finally {
			setLoading(false)
		}
	}


	return <Card key={key} className="p-2 mt-2">
		<CardEndereco
			id={endereco["es.ponto"]}
			endereco={endereco["e.rua"]}
			className="mb-2 py-2"
			observacao={endereco["e.responsavel"]}
			icone
		/>
		{loading
			? <div className="text-center">
				<CircularProgress />
			</div>
			: endereco["es.saida"]
				? <div
					className="flex justify-center text-red-600 align-item-center"
					style={{
						position: "relative",
						display: "flex",
						alignItems: "center",
						height: "2.5rem"
					}}
				>
					<Close />
					Coleta reportada

					<IconButton
						color="success"
						style={{
							position: "absolute",
							right: 0
						}}
						onClick={() => clearAddress(endereco["e.id"])}
					>
						<Edit />
					</IconButton>
				</div>
				: endereco["es.dataColeta"]
					? <div
						className="flex justify-center text-center align-item-center"
						style={{
							position: "relative",
							display: "flex",
							alignItems: "center",
							height: "2.5rem"
						}}
					>
						<Check />
						Coleta confirmada

						<IconButton
							color="success"
							style={{
								position: "absolute",
								right: 0
							}}
							onClick={() => clearAddress(endereco["e.id"])}
						>
							<Edit />
						</IconButton>
					</div>
					: <div className="flex gap-2">
						<Button
							color="success"
							variant="contained"
							startIcon={<Check fontSize='22px' />}
							className="leading-none"
							onClick={() => confirm(endereco)}
							fullWidth
						>
							Confirmar
						</Button>
						<Button
							color="error"
							variant="contained"
							startIcon={<Close fontSize='22px' />}
							className="leading-none"
							onClick={() => report(endereco)}
							fullWidth
						>
							Reportar
						</Button>
					</div>}
	</Card>
}

function ListaEnderecos({ show, pergunta, enderecos, reload }) {
	return <Backdrop in={show}>
		<Card className="p-2 mx-3">
			<h5 className="text-center">{pergunta}</h5>
			<div style={{ maxHeight: "80vh", overflowY: "auto" }}>
				{enderecos && enderecos.map((end, i) => {
					if (!end["es.saida"])
						return <AddressCapsule reload={reload} end={end} i={i} />
				})}
			</div>
		</Card>
	</Backdrop>
}

function AddressCapsule({ end, i, reload }) {
	const { id } = useParams()
	const navigate = useNavigate()
	const { dados, setDados } = useContext(ContextoGeral)

	const [show, setShow] = useState(false)

	return <Zoom in>
		<div className="m-2">
			<CardEndereco
				id={i + 1}
				className="py-2"
				onClick={() => setShow(true)}
				endereco={end['e.rua']}
				complemento={end['e.complemento']}
				tel={end['e.telefone']}
				contato={end['e.contato']}
				recebimento={end['e.endPontoReceber']}
				observacao={end["e.responsavel"]}
			/>
			<Backdrop in={show} sx={{
				zIndex: 10000
			}}>
				<Card className="p-3" style={{ width: "80vw" }}>
					<div className='leading-none text-center mb-2 font-normal'>
						Confirma ir para o endereço a seguir?
					</div>
					<CardEndereco
						id={i + 1}
						className="p-2"
						onClick={() => setShow(prev => !prev)}
						endereco={end['e.rua']}
						complemento={end['e.complemento']}
						tel={end['e.telefone']}
						contato={end['e.contato']}
						recebimento={end['e.endPontoReceber']}
						observacao={end["e.responsavel"]}
						icone
					/>
					<div className='flex gap-3 mt-4'>
						<Button
							variant='contained'
							onClick={() => {
								ServicoAPI.informarProxEntrega(dados, {
									idProf: dados.idProf,
									idServico: id,
									proximoEnd: end["e.id"]
								}).then(res => {
									setShow(false)
									if (res.resultado || res.data.resultado)
										reload()
									else if (AndroidInterface)
										AndroidInterface.showAndroidVersion(res.mensagem)
									else
										alert(res.mensagem)
								}).catch(rej => {
									console.log("ali: ", rej)
								})
							}}
							fullWidth
						>sim</Button>
						<Button
							variant="contained"
							onClick={() => setShow(false)}
							color="error"
							fullWidth
						>não</Button>
					</div>
				</Card>
			</Backdrop>
		</div>
	</Zoom>
}

function CancelAcerto({ open, onClose }) {
	const { id } = useParams()
	const { dados } = useContext(ContextoGeral)

	const [loading, setLoading] = useState(false)
	const [success, setSuccess] = useState(false)
	const [opt, setOpt] = useState("")

	async function onSubmit() {
		setLoading(true)
		setSuccess(false)
		ServicoAPI.cancelarServicoAcerto(dados, id, opt).then(res => {
			if (res.codigo == 200) {
				setSuccess(true)
				setTimeout(() => onClose(), 2500)
			}
		}).finally(() => {
			setLoading(false)
		})
	}

	return <Backdrop in={open ?? false} onClose={onClose} unmountOnExit>
		<Card className="p-3 w-3/4">
			<h5>Cancelar este serviço?</h5>
			<FormControl fullWidth>
				<InputLabel>Selecione uma ação</InputLabel>
				<Select label="Selecione uma ação" value={opt} onChange={(e, v) => setOpt(e.target.value)} required fullWidth>
					<MenuItem value="" disabled></MenuItem>
					<MenuItem value="CS">Cancelar de vez o serviço.</MenuItem>
					<MenuItem value="RS">Reabrir para outros executarem.</MenuItem>
					<MenuItem value="DSP">Deixar o serviço sem profissional.</MenuItem>
				</Select>
			</FormControl>
			<Collapse in={opt != ""}>
				<div className="mt-2 flex gap-3">
					<Button
						onClick={onSubmit}
						variant="contained"
						color="success"
						fullWidth
					>Sim</Button>
					<Button
						onClick={onClose}
						variant="contained"
						color="error"
						fullWidth
					>Não</Button>
				</div>
			</Collapse>
			<Collapse in={loading}>
				<div className="mt-4 text-center">
					<CircularProgress />
				</div>
			</Collapse>
			<Collapse in={success}>
				<Alert severity="success" className="mt-4">
					Sucesso! Aguarde
				</Alert>
			</Collapse>
		</Card>
	</Backdrop>
}


const StyledMenu = styled((props) => (
	<Menu
		elevation={0}
		anchorOrigin={{
			vertical: 'bottom',
			horizontal: 'right',
		}}
		transformOrigin={{
			vertical: 'top',
			horizontal: 'right',
		}}
		{...props}
	/>
))(({ theme }) => ({
	'& .MuiPaper-root': {
		borderRadius: 6,
		marginTop: theme.spacing(1),
		minWidth: 180,
		color:
			theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
		boxShadow:
			'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
		'& .MuiMenu-list': {
			padding: '4px 0',
		},
		'& .MuiMenuItem-root': {
			'& .MuiSvgIcon-root': {
				fontSize: 18,
				color: theme.palette.text.secondary,
				marginRight: theme.spacing(1.5),
			},
			'&:active': {
				backgroundColor: alpha(
					theme.palette.primary.main,
					theme.palette.action.selectedOpacity,
				),
			},
		},
	},
}))
